"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  CATEGORY_3D_MOVEMENT: () => CATEGORY_3D_MOVEMENT,
  CATEGORY_3D_PRINTING: () => CATEGORY_3D_PRINTING,
  CATEGORY_3D_PRINT_ACCESSORIES: () => CATEGORY_3D_PRINT_ACCESSORIES,
  CATEGORY_BALL_BEARINGS: () => CATEGORY_BALL_BEARINGS,
  CATEGORY_BALL_TRANSFER_UNIT: () => CATEGORY_BALL_TRANSFER_UNIT,
  CATEGORY_BAR_STOCKS: () => CATEGORY_BAR_STOCKS,
  CATEGORY_BUS_CABLE: () => CATEGORY_BUS_CABLE,
  CATEGORY_CABLES_FOR_MOTION: () => CATEGORY_CABLES_FOR_MOTION,
  CATEGORY_CF: () => CATEGORY_CF,
  CATEGORY_COATINGS: () => CATEGORY_COATINGS,
  CATEGORY_CONNECTING_CABLES: () => CATEGORY_CONNECTING_CABLES,
  CATEGORY_CONNECTORS: () => CATEGORY_CONNECTORS,
  CATEGORY_CONVEYOR_ROLLERS: () => CATEGORY_CONVEYOR_ROLLERS,
  CATEGORY_DRYGEAR_ACCESSORIES: () => CATEGORY_DRYGEAR_ACCESSORIES,
  CATEGORY_DRYGEAR_GEAR_TECHNOLOGY: () => CATEGORY_DRYGEAR_GEAR_TECHNOLOGY,
  CATEGORY_DRYGEAR_WORM_GEAR_ACCESSORIES: () => CATEGORY_DRYGEAR_WORM_GEAR_ACCESSORIES,
  CATEGORY_DRYGEAR_WORM_GEAR_JOINTS_ASYMMETRICAL: () => CATEGORY_DRYGEAR_WORM_GEAR_JOINTS_ASYMMETRICAL,
  CATEGORY_DRYLIN_C_ROLLER_GUIDES: () => CATEGORY_DRYLIN_C_ROLLER_GUIDES,
  CATEGORY_DRYLIN_LEAD_SCREW_TECHNOLOGY: () => CATEGORY_DRYLIN_LEAD_SCREW_TECHNOLOGY,
  CATEGORY_DRYLIN_LINEAR_TECHNOLOGY: () => CATEGORY_DRYLIN_LINEAR_TECHNOLOGY,
  CATEGORY_DRYLIN_NT_TELESCOPIC_RAILS: () => CATEGORY_DRYLIN_NT_TELESCOPIC_RAILS,
  CATEGORY_DRYLIN_N_LOW_PROFILE_GUIDES: () => CATEGORY_DRYLIN_N_LOW_PROFILE_GUIDES,
  CATEGORY_DRYLIN_Q_LINEAR_SQUARE_GUIDES: () => CATEGORY_DRYLIN_Q_LINEAR_SQUARE_GUIDES,
  CATEGORY_DRYLIN_R_SHAFT_GUIDES: () => CATEGORY_DRYLIN_R_SHAFT_GUIDES,
  CATEGORY_DRYLIN_T_RAIL_GUIDE: () => CATEGORY_DRYLIN_T_RAIL_GUIDE,
  CATEGORY_DRYLIN_W_PROFILE_GUIDES: () => CATEGORY_DRYLIN_W_PROFILE_GUIDES,
  CATEGORY_E_CHAIN: () => CATEGORY_E_CHAIN,
  CATEGORY_E_CHAINS_ACCESSORIES: () => CATEGORY_E_CHAINS_ACCESSORIES,
  CATEGORY_E_CHAIN_GUIDE_TROUGHS: () => CATEGORY_E_CHAIN_GUIDE_TROUGHS,
  CATEGORY_E_CHAIN_HORIZONTAL_SHELVES: () => CATEGORY_E_CHAIN_HORIZONTAL_SHELVES,
  CATEGORY_E_CHAIN_INTERIOR_SEPARATORS: () => CATEGORY_E_CHAIN_INTERIOR_SEPARATORS,
  CATEGORY_E_CHAIN_LINEAR_MOVEMENT: () => CATEGORY_E_CHAIN_LINEAR_MOVEMENT,
  CATEGORY_E_CHAIN_MOUNTING_BRACKETS: () => CATEGORY_E_CHAIN_MOUNTING_BRACKETS,
  CATEGORY_E_CHAIN_OPENER: () => CATEGORY_E_CHAIN_OPENER,
  CATEGORY_E_CHAIN_SMART_IOT_SOLUTIONS: () => CATEGORY_E_CHAIN_SMART_IOT_SOLUTIONS,
  CATEGORY_E_CHAIN_SPECIAL_SOLUTIONS: () => CATEGORY_E_CHAIN_SPECIAL_SOLUTIONS,
  CATEGORY_E_CHAIN_STRAIN_RELIEFS: () => CATEGORY_E_CHAIN_STRAIN_RELIEFS,
  CATEGORY_FLANGE_BALL_BEARINGS: () => CATEGORY_FLANGE_BALL_BEARINGS,
  CATEGORY_GEARS_GEAR_RACKS: () => CATEGORY_GEARS_GEAR_RACKS,
  CATEGORY_HARNESSED_CABLES: () => CATEGORY_HARNESSED_CABLES,
  CATEGORY_IGUBAL_COUPLING_JOINTS: () => CATEGORY_IGUBAL_COUPLING_JOINTS,
  CATEGORY_IGUBAL_DOUBLE_JOINTS: () => CATEGORY_IGUBAL_DOUBLE_JOINTS,
  CATEGORY_IGUBAL_SELF_ALIGNING_BEARINGS: () => CATEGORY_IGUBAL_SELF_ALIGNING_BEARINGS,
  CATEGORY_LINER: () => CATEGORY_LINER,
  CATEGORY_LOW_COST_AUTOMATION: () => CATEGORY_LOW_COST_AUTOMATION,
  CATEGORY_MOTORS: () => CATEGORY_MOTORS,
  CATEGORY_MOTOR_FLANGES: () => CATEGORY_MOTOR_FLANGES,
  CATEGORY_MOTOR_GEAR_BOXES: () => CATEGORY_MOTOR_GEAR_BOXES,
  CATEGORY_PMA: () => CATEGORY_PMA,
  CATEGORY_PNEUMATIC_HOSES: () => CATEGORY_PNEUMATIC_HOSES,
  CATEGORY_PRODUCT_STRUCTURE: () => CATEGORY_PRODUCT_STRUCTURE,
  CATEGORY_RADIAL_BALL_BEARINGS: () => CATEGORY_RADIAL_BALL_BEARINGS,
  CATEGORY_READYCABLE_HUMANOID_ROBOTS: () => CATEGORY_READYCABLE_HUMANOID_ROBOTS,
  CATEGORY_READYCABLE_POWERCABLE_WITH_M12_CONNECTOR: () => CATEGORY_READYCABLE_POWERCABLE_WITH_M12_CONNECTOR,
  CATEGORY_READYCABLE_STAGE_TECHNOLOGY: () => CATEGORY_READYCABLE_STAGE_TECHNOLOGY,
  CATEGORY_ROBOTICS: () => CATEGORY_ROBOTICS,
  CATEGORY_ROLLERS: () => CATEGORY_ROLLERS,
  CATEGORY_ROTARY_MOVEMENT: () => CATEGORY_ROTARY_MOVEMENT,
  CATEGORY_SLEWING_RINGS_AND_SLEWING_RING_BEARINGS: () => CATEGORY_SLEWING_RINGS_AND_SLEWING_RING_BEARINGS,
  CATEGORY_SPHERICAL_BALLS: () => CATEGORY_SPHERICAL_BALLS,
  CATEGORY_TOOTHED_SLEWING_RINGS: () => CATEGORY_TOOTHED_SLEWING_RINGS,
  isCategoryEnabled: () => isCategoryEnabled
});
module.exports = __toCommonJS(index_exports);

// src/categories.helper.ts
var CATEGORY_PRODUCT_STRUCTURE = "Product_structure";
var CATEGORY_CF = "CF";
var CATEGORY_BUS_CABLE = "bus_cable";
var CATEGORY_ROLLERS = "rollers";
var CATEGORY_HARNESSED_CABLES = "harnessed_cables";
var CATEGORY_PNEUMATIC_HOSES = "pneumatic_hoses";
var CATEGORY_CABLES_FOR_MOTION = "cables_for_motion";
var CATEGORY_SLEWING_RINGS_AND_SLEWING_RING_BEARINGS = "slewing_rings_and_slewing_ring_bearings";
var CATEGORY_GEARS_GEAR_RACKS = "gears_gear_racks";
var CATEGORY_E_CHAIN = "e_chains";
var CATEGORY_E_CHAIN_INTERIOR_SEPARATORS = "interior_separators";
var CATEGORY_E_CHAIN_MOUNTING_BRACKETS = "mounting_brackets";
var CATEGORY_E_CHAIN_HORIZONTAL_SHELVES = "horizontal_shelves";
var CATEGORY_E_CHAIN_LINEAR_MOVEMENT = "linear_movement";
var CATEGORY_E_CHAIN_STRAIN_RELIEFS = "strain_reliefs";
var CATEGORY_E_CHAIN_SMART_IOT_SOLUTIONS = "smart_iot_solutions";
var CATEGORY_E_CHAINS_ACCESSORIES = "Accessories_e_chains";
var CATEGORY_E_CHAIN_GUIDE_TROUGHS = "guide_troughs";
var CATEGORY_E_CHAIN_OPENER = "echain_opener";
var CATEGORY_E_CHAIN_SPECIAL_SOLUTIONS = "special_solutions";
var CATEGORY_DRYGEAR_GEAR_TECHNOLOGY = "gear_technology";
var CATEGORY_IGUBAL_SELF_ALIGNING_BEARINGS = "self_aligning_bearings";
var CATEGORY_DRYLIN_LEAD_SCREW_TECHNOLOGY = "drylin_lead_screw_technology";
var CATEGORY_DRYLIN_LINEAR_TECHNOLOGY = "drylin_linear_technology";
var CATEGORY_DRYLIN_N_LOW_PROFILE_GUIDES = "n_low_profile_guides";
var CATEGORY_DRYLIN_W_PROFILE_GUIDES = "w_profileguides";
var CATEGORY_DRYLIN_T_RAIL_GUIDE = "t_rail_guide";
var CATEGORY_DRYLIN_R_SHAFT_GUIDES = "r_shaft_guides";
var CATEGORY_DRYLIN_C_ROLLER_GUIDES = "c_roller_guides";
var CATEGORY_DRYLIN_Q_LINEAR_SQUARE_GUIDES = "q_linear_square_guide";
var CATEGORY_DRYLIN_NT_TELESCOPIC_RAILS = "nt_telescopic_rails";
var CATEGORY_MOTOR_FLANGES = "motor_flanges";
var CATEGORY_MOTOR_GEAR_BOXES = "motor_gearboxes";
var CATEGORY_CONNECTING_CABLES = "connecting_cables";
var CATEGORY_MOTORS = "motors";
var CATEGORY_BALL_BEARINGS = "ball_bearings";
var CATEGORY_RADIAL_BALL_BEARINGS = "radial_ball_bearings";
var CATEGORY_FLANGE_BALL_BEARINGS = "flange_ball_bearings";
var CATEGORY_COATINGS = "coatings";
var CATEGORY_LINER = "liner";
var CATEGORY_3D_PRINTING = "3D_printing_materials";
var CATEGORY_3D_MOVEMENT = "3D_movement";
var CATEGORY_ROTARY_MOVEMENT = "rotary_movement";
var CATEGORY_BAR_STOCKS = "bar_stocks";
var CATEGORY_LOW_COST_AUTOMATION = "low_cost_automation";
var CATEGORY_ROBOTICS = "robotics";
var CATEGORY_CONNECTORS = "connectors";
var CATEGORY_PMA = "PMA_protective_hoses_and_accessories";
var CATEGORY_TOOTHED_SLEWING_RINGS = "toothed_slewing_rings";
var CATEGORY_SPHERICAL_BALLS = "spherical_balls";
var CATEGORY_BALL_TRANSFER_UNIT = "ball_transfer_unit";
var CATEGORY_CONVEYOR_ROLLERS = "conveyor_rollers";
var CATEGORY_IGUBAL_DOUBLE_JOINTS = "double_joints";
var CATEGORY_IGUBAL_COUPLING_JOINTS = "variable_double_joint";
var CATEGORY_DRYGEAR_ACCESSORIES = "drygear_accessories";
var CATEGORY_DRYGEAR_WORM_GEAR_JOINTS_ASYMMETRICAL = "worm_gear_joints_asymmetrical";
var CATEGORY_DRYGEAR_WORM_GEAR_ACCESSORIES = "acessory_worm_gears";
var CATEGORY_READYCABLE_STAGE_TECHNOLOGY = "stage_technology";
var CATEGORY_READYCABLE_POWERCABLE_WITH_M12_CONNECTOR = "powercable_with_M12_connector";
var CATEGORY_READYCABLE_HUMANOID_ROBOTS = "humanoid_robots";
var CATEGORY_3D_PRINT_ACCESSORIES = "3D_print_accessories";
var isCategoryEnabled = /* @__PURE__ */ __name((categoryKeys, featureFlags, defaultValue = false) => {
  if (categoryKeys.includes(CATEGORY_LOW_COST_AUTOMATION)) {
    return !!featureFlags.get("showLowCostAutomation");
  }
  if (categoryKeys.some((ck) => ck && [
    CATEGORY_E_CHAIN_SMART_IOT_SOLUTIONS,
    CATEGORY_E_CHAIN_OPENER,
    CATEGORY_E_CHAIN_SPECIAL_SOLUTIONS
  ].includes(ck))) {
    return true;
  }
  if (categoryKeys.includes(CATEGORY_E_CHAIN)) {
    return !featureFlags.get("showEChainReleasedModelsOnly");
  }
  if (categoryKeys.includes(CATEGORY_READYCABLE_STAGE_TECHNOLOGY)) {
    return !!featureFlags.get("showReadycableStageTechnology");
  }
  if (categoryKeys.includes(CATEGORY_READYCABLE_POWERCABLE_WITH_M12_CONNECTOR)) {
    return !!featureFlags.get("showReadycablePowercableWithM12Connector");
  }
  if (categoryKeys.includes(CATEGORY_READYCABLE_HUMANOID_ROBOTS)) {
    return !!featureFlags.get("showReadycableHumanoidRobots");
  }
  if (categoryKeys.some((ck) => ck && [
    CATEGORY_3D_PRINTING,
    CATEGORY_ROLLERS,
    CATEGORY_CONNECTING_CABLES,
    CATEGORY_MOTORS,
    CATEGORY_MOTOR_FLANGES,
    CATEGORY_DRYLIN_LEAD_SCREW_TECHNOLOGY,
    CATEGORY_CF,
    CATEGORY_E_CHAIN_GUIDE_TROUGHS,
    CATEGORY_E_CHAIN_INTERIOR_SEPARATORS,
    CATEGORY_E_CHAIN_STRAIN_RELIEFS,
    CATEGORY_E_CHAIN_HORIZONTAL_SHELVES,
    CATEGORY_E_CHAIN_MOUNTING_BRACKETS,
    CATEGORY_E_CHAIN_LINEAR_MOVEMENT,
    CATEGORY_3D_MOVEMENT,
    CATEGORY_LINER,
    CATEGORY_HARNESSED_CABLES,
    CATEGORY_PNEUMATIC_HOSES,
    CATEGORY_CABLES_FOR_MOTION,
    CATEGORY_SLEWING_RINGS_AND_SLEWING_RING_BEARINGS,
    CATEGORY_GEARS_GEAR_RACKS,
    CATEGORY_BALL_BEARINGS,
    CATEGORY_DRYGEAR_GEAR_TECHNOLOGY,
    CATEGORY_IGUBAL_SELF_ALIGNING_BEARINGS,
    CATEGORY_DRYLIN_T_RAIL_GUIDE,
    CATEGORY_DRYLIN_R_SHAFT_GUIDES,
    CATEGORY_DRYLIN_C_ROLLER_GUIDES,
    CATEGORY_DRYLIN_Q_LINEAR_SQUARE_GUIDES,
    CATEGORY_DRYLIN_N_LOW_PROFILE_GUIDES,
    CATEGORY_DRYLIN_W_PROFILE_GUIDES,
    CATEGORY_DRYLIN_NT_TELESCOPIC_RAILS,
    CATEGORY_COATINGS,
    CATEGORY_BAR_STOCKS,
    CATEGORY_CONNECTORS,
    CATEGORY_PMA,
    CATEGORY_ROBOTICS
  ].includes(ck))) {
    return true;
  }
  if (categoryKeys.includes(CATEGORY_DRYLIN_LINEAR_TECHNOLOGY)) {
    return !!featureFlags.get("showDrylinLinearTechnology");
  }
  return defaultValue;
}, "isCategoryEnabled");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CATEGORY_3D_MOVEMENT,
  CATEGORY_3D_PRINTING,
  CATEGORY_3D_PRINT_ACCESSORIES,
  CATEGORY_BALL_BEARINGS,
  CATEGORY_BALL_TRANSFER_UNIT,
  CATEGORY_BAR_STOCKS,
  CATEGORY_BUS_CABLE,
  CATEGORY_CABLES_FOR_MOTION,
  CATEGORY_CF,
  CATEGORY_COATINGS,
  CATEGORY_CONNECTING_CABLES,
  CATEGORY_CONNECTORS,
  CATEGORY_CONVEYOR_ROLLERS,
  CATEGORY_DRYGEAR_ACCESSORIES,
  CATEGORY_DRYGEAR_GEAR_TECHNOLOGY,
  CATEGORY_DRYGEAR_WORM_GEAR_ACCESSORIES,
  CATEGORY_DRYGEAR_WORM_GEAR_JOINTS_ASYMMETRICAL,
  CATEGORY_DRYLIN_C_ROLLER_GUIDES,
  CATEGORY_DRYLIN_LEAD_SCREW_TECHNOLOGY,
  CATEGORY_DRYLIN_LINEAR_TECHNOLOGY,
  CATEGORY_DRYLIN_NT_TELESCOPIC_RAILS,
  CATEGORY_DRYLIN_N_LOW_PROFILE_GUIDES,
  CATEGORY_DRYLIN_Q_LINEAR_SQUARE_GUIDES,
  CATEGORY_DRYLIN_R_SHAFT_GUIDES,
  CATEGORY_DRYLIN_T_RAIL_GUIDE,
  CATEGORY_DRYLIN_W_PROFILE_GUIDES,
  CATEGORY_E_CHAIN,
  CATEGORY_E_CHAINS_ACCESSORIES,
  CATEGORY_E_CHAIN_GUIDE_TROUGHS,
  CATEGORY_E_CHAIN_HORIZONTAL_SHELVES,
  CATEGORY_E_CHAIN_INTERIOR_SEPARATORS,
  CATEGORY_E_CHAIN_LINEAR_MOVEMENT,
  CATEGORY_E_CHAIN_MOUNTING_BRACKETS,
  CATEGORY_E_CHAIN_OPENER,
  CATEGORY_E_CHAIN_SMART_IOT_SOLUTIONS,
  CATEGORY_E_CHAIN_SPECIAL_SOLUTIONS,
  CATEGORY_E_CHAIN_STRAIN_RELIEFS,
  CATEGORY_FLANGE_BALL_BEARINGS,
  CATEGORY_GEARS_GEAR_RACKS,
  CATEGORY_HARNESSED_CABLES,
  CATEGORY_IGUBAL_COUPLING_JOINTS,
  CATEGORY_IGUBAL_DOUBLE_JOINTS,
  CATEGORY_IGUBAL_SELF_ALIGNING_BEARINGS,
  CATEGORY_LINER,
  CATEGORY_LOW_COST_AUTOMATION,
  CATEGORY_MOTORS,
  CATEGORY_MOTOR_FLANGES,
  CATEGORY_MOTOR_GEAR_BOXES,
  CATEGORY_PMA,
  CATEGORY_PNEUMATIC_HOSES,
  CATEGORY_PRODUCT_STRUCTURE,
  CATEGORY_RADIAL_BALL_BEARINGS,
  CATEGORY_READYCABLE_HUMANOID_ROBOTS,
  CATEGORY_READYCABLE_POWERCABLE_WITH_M12_CONNECTOR,
  CATEGORY_READYCABLE_STAGE_TECHNOLOGY,
  CATEGORY_ROBOTICS,
  CATEGORY_ROLLERS,
  CATEGORY_ROTARY_MOVEMENT,
  CATEGORY_SLEWING_RINGS_AND_SLEWING_RING_BEARINGS,
  CATEGORY_SPHERICAL_BALLS,
  CATEGORY_TOOTHED_SLEWING_RINGS,
  isCategoryEnabled
});
